import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { SITE, PRIMARY_PHONE } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-[#072A47] text-slate-200" data-testid="site-footer">
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Melo Hopeful Care" className="h-14 w-14 bg-white rounded-xl p-1.5" />
            <div>
              <div className="font-heading font-semibold text-white text-lg">Melo Hopeful Care LLC</div>
              <div className="text-xs uppercase tracking-[0.22em] text-teal-300">The Heart of Home Care</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-300 max-w-md leading-relaxed">
            Non-medical in-home care for seniors and adults across the Kansas City metro, the Omaha metro and Council Bluffs.
            Compassionate, dependable support — so loved ones can stay where they feel most at home.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition" data-testid="footer-facebook"><Facebook className="w-4 h-4" /></a>
            <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
            <a href="#" aria-label="LinkedIn" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition" data-testid="footer-linkedin"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-[0.18em]">Explore</div>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/services" className="hover:text-white" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/service-areas" className="hover:text-white" data-testid="footer-link-service-areas">Service Areas</Link></li>
            <li><Link to="/referral-partners" className="hover:text-white" data-testid="footer-link-partners">Referral Partners</Link></li>
            <li><Link to="/careers" className="hover:text-white" data-testid="footer-link-careers">Careers</Link></li>
            <li><Link to="/consultation" className="hover:text-white" data-testid="footer-link-consultation">Free Consultation</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-[0.18em]">Contact</div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-teal-300" /> <a href={`tel:${PRIMARY_PHONE.tel}`} data-testid="footer-phone">{PRIMARY_PHONE.display}</a></li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-teal-300" /> <a href={`mailto:${SITE.email}`} data-testid="footer-email">{SITE.email}</a></li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-teal-300" /> <span data-testid="footer-address">{SITE.address.line1}<br />{SITE.address.line2}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Melo Hopeful Care LLC. All rights reserved. "Melo Hopeful Care" and the MHC mark are trademarks of Melo Hopeful Care LLC.</div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <span className="inline-flex items-center gap-2"><ShieldCheck className="w-3.5 h-3.5 text-teal-300" /> HIPAA awareness training for all staff</span>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link>
            <Link to="/terms#s31-accessibility" className="hover:text-white" data-testid="footer-accessibility">Accessibility</Link>
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin">Staff Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
